var React = require('react');

function Star (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M21.7662 8.72246L16.9454 13.4218L18.0838 20.0591C18.1334 20.3493 18.0142 20.6426 17.7758 20.816C17.6412 20.9143 17.4809 20.9638 17.3207 20.9638C17.1977 20.9638 17.0739 20.9344 16.9609 20.8748L11 17.7412L5.03991 20.874C4.77987 21.0118 4.46333 20.9894 4.22496 20.8152C3.98659 20.6419 3.8674 20.3485 3.91693 20.0583L5.05539 13.421L0.233766 8.72246C0.0232549 8.5166 -0.0533649 8.20857 0.0379597 7.92918C0.129284 7.64979 0.371527 7.44469 0.663301 7.40213L7.32612 6.43471L10.3058 0.396449C10.5666 -0.13215 11.4334 -0.13215 11.6942 0.396449L14.6739 6.43471L21.3367 7.40213C21.6285 7.44469 21.8707 7.64901 21.962 7.92918C22.0534 8.20934 21.9767 8.51582 21.7662 8.72246Z"}));
}

Star.defaultProps = {"width":"22","height":"21","viewBox":"0 0 22 21","fill":"none"};

module.exports = Star;

Star.default = Star;
